module.exports = __webpack_public_path__ + "static/media/Logo_rangkas_gold.1ecc5719.png";